// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2ykbA","modalFooterButton":"ModalNotes_modalFooterButton__HlgX4"};